module.exports = __webpack_public_path__ + "line-awesome.8b1290595e57e1d49d95.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.woff?v=1.1.
// module id = ../../../../../src/assets/metronic/src/vendors/line-awesome/fonts/line-awesome.woff?v=1.1.
// module chunks = styles